export const urls = {
  sendEmail: "/sendEmail",
}
